import {BackendModule} from '../modules/backend.module';
import {Injectable} from '@angular/core';
import {SessionService} from './session';

@Injectable()
export class StudiosService {
  studios: any = [];

  constructor(public backendModule: BackendModule,
              public sessionService: SessionService) {
  }

  loadAll() {
    this.studios = [];
    this.backendModule.getAPI(
      'gyms',
      {
        observe: 'body', /*default body other options: response*/
      }
    ).subscribe(
      (data: any) => {
        data.forEach((studio) => {
          if (studio.disabled) {
            return;
          }

          if (studio.gym_type === 'beauty') {
            return;
          }

          this.studios.push(studio);
        });
      },
      (err) => {
        this.sessionService.reportError('studiosService', 'loadAll()', err);
      }
    );
  }

  loadOne(studioId) {
    return new Promise((resolve, reject) => {
      this.backendModule.getAPI(
        `gyms/${studioId}`,
        {observe: 'body', /*default body other options: response*/}
      ).subscribe(
        (data: any) => {
          resolve(data)
        }, (err) => {
          this.sessionService.reportError('studiosService', 'loadOne()', err);
        }
      );
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/studios.ts